// import './registerServiceWorker'
import Vue from 'vue'
import App from './web.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import Print from 'vue-printjs'
import VueClipboard from 'vue-clipboard2'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
// import IO from 'socket.io-client'
import VCalendar from 'v-calendar'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import BtnsS from './components/btn/btns.vue'
import BtnSave from './components/btn/save.vue'
import RT from './components/radio/r1.vue'
import DialogDef2 from './components/dialognoPadding2.vue'
import Select1 from './components/select.vue'
import BoxCube from './components/LINE/box.vue'
import IconBox from './components/LINE/icon.vue'
import ImageBox from './components/LINE/image.vue'
import TextBox from './components/LINE/text.vue'
import Selector from './components/LINE/Selector.vue'
import BtnBox from './components/LINE/button.vue'
import Bubble from './components/LINE/Bubble.vue'
import Carousel from './components/LINE/Carousel.vue'
import Hero from './components/LINE/Hero.vue'
import BoxEdit from './components/LINE/boxEdit.vue'
import SelectorEdit from './components/LINE/SelectorEdit.vue'
import comfirmVue from './components/comfirm.vue'
import { getapi } from './store/fetch'

// const ws = process.env.VUE_APP_WS
console.log('process.env.BASE_URL', process.env.BASE_URL)
Vue.component('comfirmVue', comfirmVue)
Vue.component('SelectorEdit', SelectorEdit)
Vue.component('BoxEdit', BoxEdit)
Vue.component('BtnBox', BtnBox)
Vue.component('Hero', Hero)
Vue.component('Bubble', Bubble)
Vue.component('Carousel', Carousel)
Vue.component('BoxCube', BoxCube)
Vue.component('IconBox', IconBox)
Vue.component('ImageBox', ImageBox)
Vue.component('TextBox', TextBox)
Vue.component('Selector', Selector)

Vue.component('BtnSave', BtnSave)
Vue.component('Select1', Select1)
Vue.component('DialogDef2', DialogDef2)
Vue.component('RT', RT)
Vue.component('BtnsS', BtnsS)
Vue.component('v-select', vSelect)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VCalendar, {
  componentPrefix: 'vc'
})
// const socket = new VueSocketIO({
//   // debug: true,
//   connection: IO(location.host, { transports: ['websocket'], path: ws + '/socket.io', autoConnect: true }),
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   }
// })
// socket.io.on('connect', () => {
//   store.commit('setSocketConnected', true)
// })
Vue.prototype.getPayway = (code) => {
  switch (code) {
    case 'LETSPAY_I':
      return '台新 PAY'
    case 'JKOS_I':
      return '街口'
    case 'LINEPAY_I':
      return 'LINEPAY'
    case 'TAIWANPAY_I':
      return '台灣 Pay'
    case 'PI_I':
      return 'PI 錢包'
    case 'ALLPAY_I':
      return '歐付寶'
    case 'GAMAPAY_I':
      return '橘子支付'
    case 'EASYPAY_I':
      return 'EASYPAY 悠遊付'
    case 'ICASHPAY_I':
      return 'icash Pay 愛金卡'
    case 'PLUSPAY_I':
      return '全盈'
    case 'PXPAY_I':
      return '全支付'
    case 'ALIPAY_O':
      return '支付寶'
    case 'WEIXIN_O':
      return '微信支付'
    case 'HANA_O':
      return 'HANA'
  }
}
Vue.prototype.getCreditType = (code) => {
  switch (code) {
    case '01':
      return 'CUP'
    case '03':
      return 'JCB'
    case '04':
      return 'VISA'
    case '05':
      return 'Mastercard'
    case '06':
      return 'AMEX'
    case '07':
      return 'Discover/Diners'
    case '09':
      return 'Smart Pay'
  }
}
Vue.prototype.getCreditStatus = (code) => {
  switch (code) {
    case '0001':
      return '交易取消'
    case '0002':
      return '請聯絡銀行'
    case '0003':
      return '超過等待時間，請重新操作。'
    case '0004':
      return '晶片讀卡錯誤，請改刷卡。'
    case '0006':
      return '授權錯誤'
    case '0007':
      return '金額錯誤'
    case '0008':
      return '感應設備異常'
    case '0000':
      return '授權成功'
  }
}
const priceEach = (item) => {
  return item.price + item.items.map(e => e.priceDiff + e.add.map(a => a.price).reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0)
}
Vue.prototype.priceEach = priceEach
Vue.prototype.setSelectionRange = (ev) => {
  ev.target.setSelectionRange(0, ev.target.value.length)
}
Vue.prototype.wait = (timeout) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, timeout)
  })
}
Vue.prototype.invertColor = (color) => {
  function toInt (a) {
    return [parseInt(a.slice(1, 3), 16), parseInt(a.slice(3, 5), 16), parseInt(a.slice(5, 7), 16)]
  }
  if (color) {
    const [red, green, blue] = toInt(color)
    const luma = (red * 0.2126 + green * 0.7152 + blue * 0.0722) / 255
    return luma > 0.73 ? '#5E5E5E' : '#FFFFFF'
  } else {
    return '#FFFFFF'
  }
}
Vue.prototype.fixCount = (num) => {
  return num.toFixed(parseInt((num * 10) % 10) > 0 ? 1 : 0)
}
Vue.prototype.fixCountFloatA = (num) => {
  return parseFloat(num.toFixed(Math.abs(parseInt((num * 10) % 10)) > 0 ? 1 : 0))
}
Vue.prototype.fixCountFloat = (num) => {
  return parseFloat(num.toFixed(parseInt((num * 10) % 10) > 0 ? 1 : 0))
}
Vue.prototype.goToInvoices = (invoices) => {
  const params = {
    // search: invoice.invoiceStart,
    search: invoices.map(e => e.id).join(','),
    date: moment(invoices[0].opDate).format('yyyy-MM-DD')
  }
  const paramsString = new URLSearchParams(params)
  if (/8080/i.test(location.host)) {
    window.open(`${location.origin}/web.html?#/SalesRecord${paramsString ? `?${paramsString.toString()}` : ''}`)
  } else {
    window.open(`${location.origin}/#/SalesRecord${paramsString ? `?${paramsString.toString()}` : ''}`)
  }
}
Vue.prototype.openPage = (invoice) => {
  const params = {
    // search: invoice.invoiceStart,
    search: invoice.id,
    date: moment(invoice.opDate).format('yyyy-MM-DD')
  }
  const paramsString = new URLSearchParams(params)
  if (/8080/i.test(location.host)) {
    window.open(`${location.origin}/web.html?#/SalesRecord${paramsString ? `?${paramsString.toString()}` : ''}`)
  } else {
    window.open(`${location.origin}${location.pathname}#/SalesRecord${paramsString ? `?${paramsString.toString()}` : ''}`)
  }
}
Vue.prototype.getCollOrders = (Orders) => {
  const sets = Array.from(new Set(Orders.map(e => {
    // console.log(e.items[0].item, e.t)
    return (e.t === 'set') ? [e.t, e.sid, e.name].join('_') : [e.t, e.items[0].item?._id, e.name].join('_')
  })))
  const sets2 = sets.map(s => {
    const [t, id] = s.split('_')
    const ss = Orders.filter(e => e.t === t)
    const f = (t === 'set') ? Array.from(ss.filter(e => e.sid === id)) : Array.from(ss.filter(e => e.items[0].item?._id === id))
    const count = f.map(e => e.count).reduce((a, b) => a + b, 0)
    const its = [].concat(...f.map(a => a.items.map(b => { return { ...b, count: a.count } })))
    const items = Array.from(new Set(its.map(a => a.item._id))).map(id => {
      const partialIts = its.filter(a => a.item._id === id)
      const count = partialIts.map(a => a.count).reduce((a, b) => a + b, 0)
      return { ...partialIts[0], count }
    })
    items.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
    return {
      ...f[0],
      priceSum: f.map(e => priceEach(e) * e.count).reduce((a, b) => a + b, 0),
      count,
      items,
      tables: f.map(e => { return { tableName: e.tableName, count: e.count } })
    }
  })
  return sets2
}
Vue.prototype.toDate = (dt) => {
  return moment(dt).format('YYYY-MM-DD')
}
Vue.prototype.toDateTime = (dt, s) => {
  if (s) {
    return dt ? moment(dt).format(`YYYY${s}MM${s}DD HH:mm`) : ''
  } else {
    return dt ? moment(dt).format('gggg-MM-DD HH:mm') : ''
  }
}

Vue.prototype.toTel = (tel) => {
  if (tel) {
    // console.log(tel.split(''), tel, tel.split('').splice(4, 0, '-'))
    const t = tel.split('')
    if (/^09/i.test(tel)) {
      t.splice(4, 0, '-')
    } else {
      t.splice(2, 0, '-')
    }

    return t.join('')
  } else {
    return ''
  }
}
Vue.prototype.formatDollar = (x) => {
  if (x) {
    const formatter = new Intl.NumberFormat('en-Us', { style: 'currency', currency: 'USD' })
    return formatter.format(parseInt(x))
  } else {
    return '-'
  }
}
Vue.prototype.formatDollarInt = (x) => {
  if (x) {
    const formatter = new Intl.NumberFormat('en-Us', { style: 'currency', currency: 'USD' })
    return formatter.format(parseInt(x)).replace(/\D00(?=\D*$)/, '')
  } else {
    return '-'
  }
}

document.addEventListener('keypress', (event) => {
  // console.log('keypress', event)
  const text = store.state.scanid + event.key

  // const text = store.state.scanid + event.code.toLowerCase().replace('key', '').replace('digit', '')
  store.commit('setScanID', text)
})
document.addEventListener('keydown', (event) => {
  if (
    event.code &&
    (
      event.code.toUpperCase() === 'CONTROLLEFT' ||
      event.code.toUpperCase() === 'CONTROLRIGHT' ||
      event.code.toUpperCase() === 'SHIFTLEFT' ||
      event.code.toUpperCase() === 'SHIFTRIGHT' ||
      event.code.toUpperCase() === 'ALTLEFT' ||
      event.code.toUpperCase() === 'ALTRIGHT' ||
      event.code.toUpperCase() === 'METALEFT' ||
      event.code.toUpperCase() === 'METARIGHT'
    )
  ) {
  } else if (event.altKey || event.ctrlKey || event.shiftKey || event.metaKey) {
    // if (event.ctrlKey && event.code.toLowerCase() === 'tab') {
    //   syncdata()
    // }
  }
})
// Vue.use(socket)
Vue.prototype.host = window.location.hostname === 'localhost' ? 'http://localhost:3000/' : window.location.origin
Vue.use(Print)
moment.locale('zh-tw')
Vue.prototype.moment = moment

// async function beforeEach (to, from, next) {
//   const needLoggedIn = to.matched.some(record => record.meta.requiresAuth)
//   const isLoggedIn = store.state.isLoggedIn

// }
// router.beforeEach(async (to, from, next) => {
//   if (to.path === '/SpecialAgencyRecord' && to.name === null) {
//     next({
//       name: 'SpecialAgencyRecord'
//     })
//   }
//   const needLoggedIn = to.matched.some(record => record.meta.requiresAuth)
//   const isLoggedIn = store.state.isLoggedIn
//   let roleMatched = false
//   const role = store.getters.myRole
//   if (isLoggedIn && role === 'admin') {
//     next()
//   } else if (!needLoggedIn) {
//     next()
//   } else if (needLoggedIn && !isLoggedIn) {
//     next({
//       name: 'LoginPage',
//       query: { nextUrl: to.fullPath }
//     })
//   } else if (isLoggedIn && needLoggedIn) {
//     const department = store.getters.myDepartment
//     roleMatched = to.matched.every(record => {
//       const LV1 = record.meta.manager
//       const LV2 = record.meta.employee
//       if (role === 'manager' && !LV1) {
//         // 全部主管
//         return true
//       } else if (role === 'employee' && !LV2) {
//         // 全部員工
//         return true
//       } else if (role === 'manager' && LV1.includes(department)) {
//         // 限制主管
//         return true
//       } else if (role === 'employee' && LV2.includes(department)) {
//         // 限制員工
//         return true
//       } else {
//         return false
//       }
//     })
//     if (roleMatched) {
//       next()
//     } else {
//       next({ name: 'permissionDenied' })
//     }
//   }
// })
router.beforeEach(async (to, from, next) => {
  const needLoggedIn = to.matched.some(record => record.meta.requiresAuth)
  const isLoggedIn = store.state.isLoggedIn
  if (!needLoggedIn) {
    next()
  } else if (needLoggedIn && !isLoggedIn) {
    next({
      name: 'LoginPage',
      query: { nextUrl: to.fullPath }
    })
  } else if (needLoggedIn && to.name === 'Home' && isLoggedIn) {
    next()
  } else if (isLoggedIn && needLoggedIn) {
    const roleMatched = await getapi(`permission/router/web/${to.name}`)
    console.log(`permission/router/web/${to.name}`, roleMatched)
    if (roleMatched) {
      next()
    } else {
      next({ name: 'permissionDenied' })
    }
  }
})
document.title = process.env.VUE_APP_STORENAME
store.dispatch('checkLogin')
  .then(() => {
  // console.log('process.env.production', window.location.hostname)
    new Vue({
      beforeCreate () {
      },
      async created () {
        // console.log('this.$route.name CREATE', this.$route.name)
        if (this.$route.path === '/') {
          // console.log('path', this.$route.name)
        }
      },
      beforeMount () {
        // console.log('beforeMount')
      },
      mounted () {
        // console.log('mounted')
      },
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
    // console.log('ck123', rest)
  })

function reduce (arr) {
  return arr.reduce((a, b) => a + b, 0)
}
Vue.prototype.reduce = reduce
